// extracted by css-extract-rspack-plugin
export default {"Panel":"ArtifactsSidePanelEmbedded-module__Panel__wlyfx","closed":"ArtifactsSidePanelEmbedded-module__closed__VF3mj","Content":"ArtifactsSidePanelEmbedded-module__Content__rzMXm"};